import { useDotSeriesData } from './useDotSeriesData.js';
import { useRectData } from './useRectData.js';
import { DOT_VARIANT, RECT_VARIANT } from '../types/xy-chart-internals.js';

type Variants = [typeof DOT_VARIANT, typeof RECT_VARIANT];

export const useGetVariants = () => {
  const shapes = [
    {
      series: useRectData().seriesWithDatapoints,
      variant: RECT_VARIANT,
    },
    {
      series: useDotSeriesData().seriesWithDatapoints,
      variant: DOT_VARIANT,
    },
  ].reduce((acc, current) => {
    if (current.series[0]?.data.length) {
      acc.push(current.variant);
    }

    return acc;
  }, [] as Partial<Variants>);

  return {
    isOnlyDotSeries: () => shapes.length === 1 && shapes.includes(DOT_VARIANT),
    shapes,
  };
};
